import { render } from "./AvastCamera.vue?vue&type=template&id=18b5003a&scoped=true"
import script from "./AvastCamera.vue?vue&type=script&lang=js"
export * from "./AvastCamera.vue?vue&type=script&lang=js"

import "./AvastCamera.vue?vue&type=style&index=0&id=18b5003a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-18b5003a"

export default script